import { Dialog, DialogContent, DialogProps, Typography } from '@mui/material'
import { Box } from '@mui/system'
import SVGPanBlock from 'assets/svgpanblock'
import React, { useState, useContext } from 'react'
import AddButton from '../AddButton'
import { AlertDialogContext } from 'hooks/AlertDialogContext'
interface AlertDialogProps {
  openDialog: boolean
}

const AlertDialog = () => {
  const { alertDialog, updateAlertDialog } = useContext(AlertDialogContext)
  return (
    <Dialog
      fullWidth
      open={alertDialog.openDialog}
      sx={{ borderRadius: '12px', ml: 2, mr: 2 }}
      id='alertdialog'
    >
      <DialogContent>
        <Box display='flex' alignItems='center' sx={{ flexDirection: 'column' }}>
          <Box sx={{ mt: 4 }}></Box>
          {alertDialog.midIcon}
          <Typography
            align='center'
            variant='h1'
            sx={{ mt: 3, width: '100%', overflowWrap: 'break-word' }}
          >
            {alertDialog.title}
          </Typography>
          <Typography
            align='center'
            variant='h3'
            sx={{ mt: 1, width: '100%', overflowWrap: 'break-word' }}
          >
            {alertDialog.subText}
          </Typography>
          <AddButton
            buttonText={alertDialog.actionName}
            sx={{ mt: 4, mb: 2 }}
            fullWidth
            onClick={alertDialog.onActionClick}
          />
        </Box>
      </DialogContent>
    </Dialog>
  )
}

export default AlertDialog
